import { css } from 'emotion';
import { colors, animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({
    display: 'flex',
    fontFamily:
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans",HelveticaNeue-Light,"Helvetica Neue Light","Helvetica Neue",Helvetica,sans-serif',
    '@media(max-width: 600px)': {
      flexDirection: 'column'
    }
  });

  export const toggleState = (isActive: boolean) => {
    return isActive
      ? css({
          opacity: 1,
          pointerEvents: 'none'
        })
      : css({
          opacity: 0.5,
          pointerEvents: 'all'
        });
  };
  export const yearToggle = (isActive: boolean) => {
    return css(
      {
        cursor: 'pointer',
        fontSize: '.9rem ',
        lineHeight: '20px'
      },
      toggleState(isActive)
    );
  };

  export const calendarToggle = (isActive: boolean) => css({ cursor: 'pointer' }, toggleState(isActive));

  // =========================
  // Form Control Styling
  // =========================

  export const inputWrapper = css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  });

  export const label = css({
    color: '#3A3C3E',
    fontSize: 15,
    fontWeight: 600,
    letterSpacing: '.2px',
    opacity: 0.6,
    paddingBottom: 3,
    transform: 'scale(.8)',
    transformOrigin: 'left'
  });

  export const input = css({
    width: '100%',
    cursor: 'pointer',
    minHeight: '48px',
    letterSpacing: '0.2px',
    color: '#333333',
    background: 'transparent',
    border: 'none',
    transition: animationTransition('background-color', 'color'),
    fontSize: 14,
    '::placeholder': {
      color: colors.gray
    }
  });

  export const groupBreak = css({
    borderBottom: '1px solid',
    borderColor: colors.light
  });
}
